import { render, staticRenderFns } from "./optionList.vue?vue&type=template&id=10144867&scoped=true"
import script from "./optionList.vue?vue&type=script&lang=js"
export * from "./optionList.vue?vue&type=script&lang=js"
import style0 from "./optionList.vue?vue&type=style&index=0&id=10144867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10144867",
  null
  
)

export default component.exports